DialogController = App.loadClass 'core::Angular/DialogController'
RatingsValidator = App.loadClass 'portal::Angular/Ratings/Ratings/RatingsValidator'
string_utils = App.load 'core::utils/string'
Handsontable = window.Handsontable

# TODO: this file is way too long and almost impossible to find anything in.
# Probably >2/3 of this crap could be refactored out into separate services.

class exports.RatingsDialogController extends DialogController

    constructor: (@scope, @transitions, @repo, @loader, @q, @state, @modal, @timeout, @window) ->
        super(@scope, @transitions)
        self = this

        # dialog sizing stuff
        @scope.fullpage = true
        @scope.visible_products = [] # updated based on show_inactive_products

        if not @scope.selected.crop?.lineups_id?
            @state.go('portal.ratings.ratings')
            return

        # loading stuff
        @loader.overMap 'Loading...'

        things_to_load = [
            @loadConfiguration(@scope.selected.crop)
            @loadProducts(@scope.selected.crop)
        ]
        @q.all(things_to_load).then (result) =>
            @validateAllData().then () =>
                @loader.hideAll()

        # scope properties
        @scope.categories = []

        @scope.table_width = 100
        @scope.fixed_headings = []
        @scope.scrolling_headings = []

        @scope.edited_by = ''
        @scope.$watch 'selected.crop.edited_by', (val) =>
            @scope.edited_by = val

        @scope.edited_at = ''
        @scope.$watch 'selected.crop.edited_at', (val) =>
            # TODO: account for time zones somehow..??
            @scope.edited_at = moment(val).format?('YYYY-MM-DD h:mma')

        @scope.products = []
        @scope.show_inactive_products = false
        @scope.has_inactive_products = false
        @scope.addProduct = @addProduct

        @scope.exportToExcel = @exportToExcel

        # controller properties
        @all_columns = {}
        @has_refuge_columns = false
        @column_groups =
            with_lengths: []
            chemistry: []
            refuge_percent: []
            refuge_option: []

        # These are to track table sorting so it can be re-applied when needed.
        # Default sorting is by Seed Company, then Name, then Trait.
        @sort_props = ['seed_company', 'name', 'trait_package']
        @sort_direction = 'asc'

        @validator = new RatingsValidator(@scope.products, @all_columns, @column_groups)
        @validating_all_cells = false
        @_cached_validation_status_callbacks = [] # cache for debouncing @getValidationStatus()
        @_cached_changes = [] # cache for debouncing @afterChange()
        @_cached_validation_statuses = [] # cache for @updateValidationAlert()

        @save_data = [] # only changed values will be saved
        @state_name = @state.current.name # for warning about unsaved changes

        # handsontable configuration
        @scope.hot_settings =
            currentColClassName: 'highlighted'
            currentRowClassName: 'highlighted'
            allowInsertColumn: false
            allowRemoveColumn: false
            allowInsertRow: false
            allowRemoveRow: false
            rowHeaders: false
            wordWrap: false
            allowInvalid: true
            invalidCellClassName: 'invalid'
            # columnSorting: true # this breaks in FF, may be fixed by updating
            # sortIndicator: true # note: only works in HOT > 0.15.0-beta3
            undo: false # undoRedo has issues - may be fixed in a later version

            # hooks
            afterInit: ->
                # this is hot
                # `this` is the HoT instance (the `Core` object)
                self.hot = this
                self.afterInit()
            afterChange: @afterChange
            afterOnCellMouseDown: @afterOnCellMouseDown
            beforeChange: @beforeChange
            beforeValidate: @beforeValidate

        # watchers
        @scope.$watch 'categories', (cats) =>
            @updateCategories(cats)
        , true # deep watch to pick up changes to active, etc

        @scope.$watch 'show_inactive_products', (show_inactive) =>
            # no need to reapply sorting or anything (they're already sorted)
            @updateVisibleProducts()

            # make sure we're showing the validation message if it needs one
            @updateValidationAlert()

        # Add Product event listeners
        deregisterers = [
            @scope.$on 'ratings.add-product:saved', (event, data) =>
                ids = _.map data.saved_products, (product) =>
                    return product.id
                @loadNewProducts(@scope.selected.crop, ids)

                @state.go('portal.ratings.ratings.dialog')

            @scope.$on 'ratings.add-product:cancelled', (event, data) =>
                @state.go('portal.ratings.ratings.dialog')
        ]

        @transitionStart = @transitions.onStart {}, ($transition) =>
            # if we're going to a child state, don't worry about unsaved changes
            if string_utils.startsWith $transition.to().name, @state_name
                return

            # if there are unsaved changes, warn the user
            if @save_data.length > 0
                if not @window.confirm('You have unsaved changes.\n\nAre you sure you want to leave this page?')
                    return false

        @window.onbeforeunload = () =>
            # if there are unsaved changes, warn the user
            if @save_data.length > 0
                return 'You have unsaved changes.'

            return null # doesn't show a warning

        # deregister the event listeners when the scope is destroyed so we
        # don't create memory leaks
        @scope.$on '$destroy', =>
            for func in deregisterers
                func()
            @transitionStart()
            @window.onbeforeunload = null


    ############
    # Messages #
    ############

    showInfo: (msg) =>
        @setAlert type: 'info', msg: msg

    showSuccess: (msg) =>
        @setAlert type: 'success', msg: msg

    showWarning: (msg) =>
        @setAlert type: 'warning', msg: msg

    showError: (msg, timeout = null) =>
        # If `timeout` is not null, it will override the default of 2000ms.
        # `false` means no timeout (message remains indefinitely)
        @setAlert type: 'error', msg: msg, timeout

    showLoadingError: (items, msg = null) =>
        if msg?
            # if there's a detailed message, include it
            msg = "Failed to load #{items}: #{msg}"
        else
            # otherwise just give a generic error
            msg = "Failed to load #{items}"

        @showError msg

    showActivationError: (item, activating, msg = null) =>
        action = if activating then 'activate' else 'deactivate'
        if msg?
            # if there's a detailed message, include it
            msg = "Failed to #{action} #{item}: #{msg}"
        else
            # otherwise just give a generic error
            msg = "Failed to #{action} #{item}"

        @showError msg

    showUpdateError: (items, msg = null) =>
        if msg?
            # if there's a detailed message, include it
            msg = "Failed to update #{items}: #{msg}"
        else
            # otherwise just give a generic error
            msg = "Failed to update #{items}"

        @showError msg


    #################
    # Configuration #
    #################

    loadConfiguration: (crop) =>
        promise = @repo.getConfiguration(crop.lineups_id).then (response) =>
            if response.status?.type isnt 'success'
                @showLoadingError('Rating Column Configuration', response.status?.msg)
                return

            # just a bit of pre-processing..
            @has_refuge_columns = _.find(response.data.categories, { display_name: 'Refuge' })?

            # clear any existing values from reference arrays/objects
            for prop, column of @all_columns
                @all_columns[prop] = null
                delete @all_columns[prop]
            @column_groups.with_lengths.length = 0
            @column_groups.chemistry.length = 0
            @column_groups.refuge_percent.length = 0
            @column_groups.refuge_option.length = 0

            for cat in response.data.categories
                for head in cat.headings
                    for col in head.columns
                        # easy way to reference columns by property name
                        @all_columns[col.column_alias] = col

            for prop, col of @all_columns
                @preprocessColumn(col)

            # add categories and any static options lists to the scope
            for key, arr of response.data
                @scope[key] = arr


        .catch (response) =>
            @showLoadingError('Rating Column Configuration')

        return promise

    preprocessColumn: (column) =>
        # TODO: refactor this (move out into a separate class?)
        possible_chemistry_columns = [
            'glyphosate'
            'glufosinate'
            # 'conventional' # for refuge purposes, this doesn't count as a trait
            'roundup_ready_2_xtend'
            'roundup_ready_2_yield'
            'libertylink'
            'enlist'
            'dicamba'
        ]

        possible_refuge_percent_columns = [
            'refuge_percent'
            'refuge_percent_south'
        ]

        possible_refuge_option_columns = [
            'refuge_option_1'
            'refuge_option_2'
            'refuge_option_3'
            'refuge_option_4'
            'refuge_option_5'
        ]

        # register these for easy reference later
        if string_utils.endsWith(column.class_name, 'Length')
            ref_column = column.column_alias.replace(/_length$/, '')
            if @all_columns[ref_column]?
                @column_groups.with_lengths.push(ref_column)
        else if column.column_alias in possible_chemistry_columns
            @column_groups.chemistry.push(column.column_alias)
        else if column.column_alias in possible_refuge_percent_columns
            @column_groups.refuge_percent.push(column.column_alias)
        else if column.column_alias in possible_refuge_option_columns
            @column_groups.refuge_option.push(column.column_alias)

        # input_type-specific stuff
        switch column.input_type
            when 'autocomplete'
                # Add a function to get the options for a given product.
                # NOTE: Getting the options each time they're needed is much
                # simpler than trying to maintain a list on the product, and
                # the performance impact seems negligible.

                if column.column_alias in ['default_treatment', 'secondary_treatment']
                    column.getOptions = @getTreatmentOptions
                else if column.column_alias in @column_groups.refuge_option
                    column.getOptions = @getRefugeOptions
                else if column.options_alias?
                    column.getOptions = () =>
                        return @scope[column.options_alias].map (option) -> option.name
                else
                    throw new Error("No function found to get options for column \"#{column.display_name}\"")

        # add class/column-specific afterChange hooks
        switch column.class_name
            when 'TreatmentOption'
                column.afterChange = @afterTreatmentOptionChange
        if @has_refuge_columns
            if column.column_alias is 'active'
                column.afterChange = @afterActiveChange
            else if column.column_alias in @column_groups.chemistry
                column.afterChange = @afterChemistryTraitChange
            else if column.column_alias in @column_groups.refuge_percent
                column.afterChange = @afterRefugePercentChange
            else if column.column_alias in @column_groups.refuge_option
                column.afterChange = @afterRefugeOptionChange

    getTreatmentOptions: (product) =>
        options = []
        for prop, column of @all_columns
            if column.class_name is 'TreatmentOption' and product[prop] is true
                options.push column.display_name
        return options

    getRefugeOptions: (product) =>
        if product.is_refuge
            return []

        options = []
        for other in @scope.products
            if other.isAValidRefugeOptionFor(product, @column_groups.chemistry, @column_groups.refuge_percent)
                options.push other.full_name
        return options

    updateCategories: (categories) =>
        if not @hot?
            # if we're not hot, why bother?
            return

        # TODO: prevent hiding a category if it contains any invalid cells

        # headings for fixed categories andneed to be handled differently
        # NOTE: fixed categories MUST be first in the list
        table_width = 0
        fixed_cat_width = 0
        fixed_headings = []
        scrolling_headings = []

        columns = []
        fixed_cols = 0

        # loop over active categories and include their columns
        for cat in categories
            # "fixing" cats and keeping them active are both good things!
            if cat.is_fixed or cat.active
                for head in cat.headings
                    head_width = 0

                    for col in head.columns
                        column = @formatColumn(col)
                        columns.push column
                        if cat.is_fixed
                            fixed_cols += 1
                        head_width += column.width

                    if head_width > 0
                        heading =
                            display_name: head.display_name
                            width: head_width
                        if cat.is_fixed
                            fixed_cat_width += head_width
                            fixed_headings.push heading
                        else
                            scrolling_headings.push heading

                    table_width += head_width

        # update scope properties
        @scope.fixed_headings = fixed_headings
        @scope.scrolling_headings = scrolling_headings
        @scope.table_width = table_width
        @scope.scrolling_headings[0]?.margin_left = fixed_cat_width

        @hot.updateSettings
            columns: columns
            fixedColumnsLeft: fixed_cols

        # make sure we're showing the validation message if it needs one
        @updateValidationAlert()

    formatColumn: (column) =>
        # do some fancy stuff
        hot_column =
            title: column.display_name
            data: column.column_alias
            type: column.input_type
            renderer: @getColumnRenderer(column)
            validator: @validateCell
            width: @getColumnWidth(column)

        if not column.is_editable
            hot_column.readOnly = true

        # input-type-specific stuff
        switch column.input_type
            when 'autocomplete'
                hot_column.editor = 'betterAutocomplete'
                hot_column.filter = true # we DO want to filter after all!
                hot_column.source = (query, callback) =>
                    row = @hot.getSelected()?[0]
                    product = @hot.getSourceDataAtRow(row)
                    if product
                        callback(column.getOptions(product))
                    else
                        callback([])

            when 'numeric'
                hot_column.format = '0[.]0[000000000]' # only show decimal if needed

        return hot_column

    getColumnRenderer: (column) =>
        # Use custom renderers with fancy validation. (Must be applied to all
        # cells, regardless of whether they actually have validation, because
        # otherwise Handsontable will have no way to clear the tooltips.)
        return 'validated' + string_utils.capitalize(column.input_type)

    getColumnWidth: (column) =>
        # if we have a custom width specified, use it
        if column.width?
            return column.width

        # some columns need a specific width
        switch column.column_alias
            when 'seed_company'
                return 110
            when 'name'
                return 120
            when 'trait_package'
                return 100
            when 'active'
                return 76

        # refuge option columns need to be wide enough to see the product name
        if column.column_alias in @column_groups.refuge_option
            return 280

        if string_utils.contains column.column_alias, 'yield_pop'
            return 75

        # otherwise set the width to 100, just so it has a fixed width for now
        # TODO: should be based on the column header width?
        return 100


    ############
    # Products #
    ############

    loadProducts: (crop) =>
        promise = @repo.getProducts(crop.lineups_id).then (response) =>
            if response.status?.type isnt 'success'
                @showLoadingError('Products', response.status?.msg)
                return

            # clear the array and populate it (rather than just assigning the
            # new array) in order to preserve existing references to it
            # Pre-allocate the correct array length and assign by index
            # See http://jsperf.com/new-array-vs-splice-vs-slice/113
            @scope.products.length = response.data.products.length
            for product, i in response.data.products
                # set the full_name
                sc = product.seed_company
                name = product.name
                tp = product.trait_package
                product.full_name = "#{sc} #{name} #{tp}".trim()

                @updateCalculatedColumns(product)
                @scope.products[i] = product

                if not product.active
                    @scope.has_inactive_products = true

            # Apply sorting
            @applySorting()

        .catch (response) =>
            @showLoadingError('Products')

        return promise

    addProduct: =>
        # There is an event listener for the saved or cancelled event broadcast
        # from AddProductDialogController, which adds the new product(s).
        @state.go('portal.ratings.ratings.dialog.add_product', null, { location: false })

    loadNewProducts: (crop, ids) =>
        promise = @repo.getProducts(crop.lineups_id, ids).then (response) =>
            if response.status?.type isnt 'success'
                @showLoadingError('New Products', response.status?.msg)
                return

            for product in response.data.products
                # set the full_name
                sc = product.seed_company
                name = product.name
                tp = product.trait_package
                product.full_name = "#{sc} #{name} #{tp}".trim()

                @updateCalculatedColumns(product)
                @scope.products.push(product)

            # make sure any sorting is maintained
            @loader.overMap 'Loading...'
            @applySorting () =>
                @loader.hideAll()

        .catch (response) =>
            @showLoadingError('New Products')

        return promise

    updateVisibleProducts: =>
        # This is a pretty efficient way to copy elements into the array
        # see http://jsperf.com/new-array-vs-splice-vs-slice/113
        if @scope.show_inactive_products
            # pre-allocating to the right length helps
            @scope.visible_products.length = @scope.products.length
            for product, i in @scope.products
                @scope.visible_products[i] = product
        else
            # we don't know the length to pre-allocate, so just clear it first
            @scope.visible_products.length = 0
            i = 0
            for product in @scope.products
                if product.active
                    @scope.visible_products[i++] = product

        # Make sure handsontable won't add extra rows if you drag-to-fill down
        # down to the bottom row.
        @hot.updateSettings
            maxRows: @scope.visible_products.length

    cancel: () =>
        # The Cancel button shouldn't actually close the dialog - it should
        # just discard any changes and reload the products from the DB.
        if not @save_data.length
            @showInfo('No changes detected since last save')
            return

        @loader.overMap 'Loading...'
        @loadProducts(@scope.selected.crop).then (result) =>
            @save_data = []
            @validateAllData().then () =>
                @loader.hideAll()

    applySorting: (callback = null) =>
        # run the sorting asynchronously
        @timeout () =>
            @scope.products.sort (a, b) =>
                for sort_prop in @sort_props
                    col = @all_columns[sort_prop]
                    if col?.class_name is 'Status'
                        result = @_statusComparator(a, b)
                    else if col?.options_alias?
                        result = @_staticOptionComparator(a, b, sort_prop, col.options_alias)
                    # TODO: add support for date sorting
                    else
                        result = @_defaultComparator(a, b, sort_prop)

                    # We'll iterate through the sort props until we find a
                    # value that isn't the same between the two products.
                    if result isnt 0
                        break

                # for descending order, we can just flip the result
                if @sort_direction is 'desc'
                    return -result

                return result

            @updateVisibleProducts()
            callback?()

    _defaultComparator: (a, b, prop) =>
        # Don't use strnatcasecmp because it's not consistent with Excel :(
        # Don't use strcasecmp because it handles null values wrong (as "null",
        # rather than as "" or as null).

        a_comp = @_getDefaultComparatorValue(a[prop], b[prop])
        b_comp = @_getDefaultComparatorValue(b[prop], a[prop])

        if a_comp > b_comp
            return 1
        else if a_comp < b_comp
            return -1
        else
            return 0

    _getDefaultComparatorValue: (val, other) =>
        comp_val = val

        # Handle special cases

        if not val?
            # comparing null with a non-numeric string doesn't work right
            if typeof other is 'string' and not $.isNumeric(other)
                comp_val = ''

        else if typeof val is 'boolean'
            # Comparing booleans and strings doesn't work right. Using '1'
            # (true) or '' (false) provides the most sensible comparison
            if typeof other is 'string' and not $.isNumeric(other)
                if val
                    comp_val = '1'
                else
                    comp_val = ''

        else if typeof val is 'string'
            # lowercase for case insensitive comparison
            comp_val = val.toLowerCase()

            # If both values are numeric, make sure to do a numeric comparison
            # because comparing strings and numbers doesn't work right. Also,
            # if the other value is an empty string, we want to do a numeric
            # comparison so '' is treated as 0 when comparing with '0' or
            # negative numeric strings.
            if $.isNumeric(val)
                if typeof other isnt 'string' or other is '' or $.isNumeric(other)
                    comp_val = parseFloat(val)

        else
            # If we get here, the value must be a number. If the other value is
            # a non-numeric string, do a string comparison instead. Empty
            # strings are also a special case because we want to do a numeric
            # comparison (e.g. -1 should be less than '').
            if typeof other is 'string' and other isnt '' and not $.isNumeric(other)
                comp_val = String(val)

        return comp_val

    _statusComparator: (a, b) =>
        # sort by activation, then by completion
        # Turns out subtracting booleans actually returns the correct result!
        result = a.active - b.active
        # If active is different, great! We're done here!
        if result isnt 0
            return result
        # Otherwise we compare is_placeable to see if that's different.
        return a.is_placeable - b.is_placeable

    _staticOptionComparator: (a, b, sort_prop, options_alias) =>
        a_comp = _.find(@scope[options_alias], name: a[sort_prop])?.value
        b_comp = _.find(@scope[options_alias], name: b[sort_prop])?.value
        return a_comp - b_comp

    _getProductAtCell: (cell) =>
        # The cell object may have a `row` property (the row number used by
        # Handsontable), or it may have an `index` property (the index of the
        # product in `@scope.products`). We can use either.
        if cell.index?
            return @scope.products[cell.index]
        else if cell.row?
            return @hot.getSourceDataAtRow(cell.row)
        else
            return null

    #########
    # Hooks #
    #########

    afterInit: () =>
        # custom properties needed for the Status column
        @hot.check_completion = @scope.selected.crop.has_spp
        @hot.activated_prop = 'active' # column_alias for the Status column
        @hot.completed_prop = 'is_placeable'

    afterChange: (changes, source) =>
        # 'external' comes from ngHandsontable if the source data is changed
        if source in ['loadData', 'external']
            return changes

        # Each time the source data changes, it kicks off $scope.$digest(). If
        # there are a lot of changes made in rapid succession, this can really
        # slow things down because it spends so much computation time on all
        # the $scope.$digest() calls. So instead of updating everything right
        # away, we cache the changes and use debounce to apply the changes all
        # at once, reducing the number of $scope.$digest() cycles needed.
        for change in changes
            @_cached_changes.push(change)

        if not @_afterChangeDebounced?
            @_afterChangeDebounced = debounce () =>
                @updateCalculatedColumnsFromChanges(@_cached_changes)
                @_updateSaveData(@_cached_changes)
                @runColumnHooks(@_cached_changes)

                @_cached_changes = []

                # debounce uses setTimeout, so we also have to update the scope
                @scope.$apply()

        @_afterChangeDebounced()
        return changes

    afterOnCellMouseDown: (event, coords, elem) =>
        # Special handling for column headers to keep track of sorting, so it
        # can be re-applied any time the visible products change. This isn't
        # ideal, but I didn't find any built-in way to tell how a Handsontable
        # is sorted, so this will have to do for now.
        if coords.row is -1
            # mousedown occurred on a header cell
            most_recent_prop = @sort_props[0]
            new_prop = @hot.colToProp(coords.col)
            # if it's same column as before, switch the direction
            if new_prop is most_recent_prop
                switch @sort_direction
                    when 'asc'
                        @sort_direction = 'desc'
                    else
                        @sort_direction = 'asc'
            else
                # remove the prop from its current position in the array and
                # put it on the front.
                i = @sort_props.indexOf(new_prop)
                if i > -1
                    @sort_props.splice(i, 1)
                @sort_props.unshift(new_prop)

                # always use ascending order the first time
                @sort_direction = 'asc'

            @loader.overMap 'Loading...'
            @applySorting () =>
                @loader.hideAll()

    beforeChange: (changes, source) =>
        # Catch cases where user has cleared one or more checkboxes via backspace or delete
        @convertEmptyStrings(changes) if changes[0]?[3]? and changes[0][3] is ''

        # coerce pasted values to booleans for checkbox columns
        # TODO: this probably won't be needed after updating to > v0.15.0
        if source in ['paste', 'autofill']
            for change, i in changes
                if change?.length isnt 4
                    continue

                [row, prop, old_val, val] = change

                if @all_columns[prop]?.input_type is 'checkbox'
                    switch typeof val
                        when 'string'
                            val = (val.toLowerCase() in ['true', 'yes', 't', 'y'])
                        else
                            val = !!val

                    # update the changes array
                    changes[i] = [row, prop, old_val, val]

        return changes

    convertEmptyStrings: (changes) =>
        for change, i in changes
            if change?.length isnt 4
                continue

            [row, prop, old_val, val] = change

            if @all_columns[prop]?.input_type is 'checkbox'
                # correct the value from an empty string to false
                val = false if val is ''
                changes[i] = [row, prop, old_val, val]

        return changes

    beforeValidate: (value, row, prop, source) =>
        # Need additional cell info to validate properly. Validator
        # functions will receive this object, not just a string value.
        cell =
            value: value
            row: row
            prop: prop
        return cell

    runColumnHooks: (changes) =>
        for change in changes
            if change?.length isnt 4
                continue

            [row, prop, old_val, val] = change
            # if there's an afterChange hook for this particular column, run it
            @all_columns[prop]?.afterChange?(change...) # I <3 CoffeeScript

    afterTreatmentOptionChange: (row, prop, old_val, val) =>
        # TODO: trigger validation on default/secondary treatment
        return

    afterActiveChange: (row, prop, old_val, val) =>
        # TODO: trigger refuge validation
        return

    afterChemistryTraitChange: (row, prop, old_val, val) =>
        # TODO: trigger refuge validation
        return

    afterRefugePercentChange: (row, prop, old_val, val) =>
        # TODO: trigger refuge validation
        return

    afterRefugeOptionChange: (row, prop, old_val, val) =>
        # TODO: trigger refuge validation
        return


    ######################
    # Calculated Columns #
    ######################

    updateCalculatedColumns: (product) =>
        for prop, column of @all_columns
            if prop in @column_groups.with_lengths
                product.updateLength(prop)

    updateCalculatedColumnsFromChanges: (changes) =>
        for change in changes
            if change?.length isnt 4
                continue

            [row, prop, old_val, val] = change

            if prop in @column_groups.with_lengths
                product = @hot.getSourceDataAtRow(row)
                product.updateLength(prop)


    ##############
    # Validation #
    ##############

    validateAllData: (callback) =>
        validators = []
        for product, i in @scope.products
            for prop, column of @all_columns
                # call the validator
                validators.push @validateCell {
                    value: product[prop]
                    index: i
                    prop: prop
                }, null, false

        return @q.all(validators)

    validateCell: (cell, callback = null, run_completion_check = true, get_messages_only = false) =>
        # cell =
        #     row: row (or index: index)
        #     prop: prop
        #     value: value
        column = @all_columns[cell.prop]

        # if it's not an editable cell, skip all the fancy stuff
        if column.is_calculated or not column.is_editable
            callback?(true)
            return

        # if there's nothing to validate, don't bother with the rest of this
        if column.validation_rules.length is 0
            if @hot.check_completion
                return @_checkCellCompletion(cell, callback, run_completion_check, get_messages_only)
            if get_messages_only
                return 'No error'
            @markValid(cell, callback)
            return

        product = @_getProductAtCell(cell)
        cell_is_valid = true
        messages = []
        promise = @q (resolve, reject) =>
            if column.validation_rules.length is 0
                resolve()

            rules_finished = 0
            for rule_str in column.validation_rules
                # call the validator
                @validator.validate rule_str, cell, product, column, get_messages_only, (is_valid, msg = null) =>
                    if not is_valid
                        cell_is_valid = false
                        if get_messages_only and msg?
                            messages.push(msg)

                    rules_finished++
                    if rules_finished is column.validation_rules.length
                        resolve()

        # when all validation rules have finished, indicate the result
        return promise.then () =>
            if cell_is_valid
                # only check completion after validation has finished (invalid
                # cells should appear invalid, regardless of completion)
                if @hot.check_completion
                    return @_checkCellCompletion(cell, callback, run_completion_check, get_messages_only)
                if get_messages_only
                    return 'No error'
                @markValid(cell, callback)
            else
                if get_messages_only
                    return messages.join('<br>')
                @markInvalid(cell, callback)
                if @hot.check_completion
                    @setProductCompletion(product, false)

    # this is for "soft" validation
    # NOTE: This function should only be called from validateCell(). If it's
    # called from elsewhere, it may mark a cell as valid, even if it's invalid.
    _checkCellCompletion: (cell, callback = null, run_completion_check = true, get_messages_only = false) =>
        # cell =
        #     row: row (or index: index)
        #     prop: prop
        #     value: value
        column = @all_columns[cell.prop]

        # if there's nothing to validate, don't bother with the rest of this
        if column.completion_rules.length is 0
            if get_messages_only
                return 'No error'
            @markValid(cell, callback)
            if not @validating_all_cells and run_completion_check
                product = @_getProductAtCell(cell)
                @checkIfProductIsComplete(product, cell)
            return

        product = @_getProductAtCell(cell)
        cell_is_complete = true
        messages = []
        promise = @q (resolve, reject) =>
            if column.completion_rules.length is 0
                resolve()

            rules_finished = 0
            for rule_str in column.completion_rules
                # call the validator
                @validator.validate rule_str, cell, product, column, get_messages_only, (is_valid, msg = null) =>
                    if not is_valid
                        cell_is_complete = false
                        if get_messages_only and msg?
                            messages.push(msg)

                    rules_finished++
                    if rules_finished is column.completion_rules.length
                        resolve()

        # when all completion rules have finished, indicate the result
        return promise.then () =>
            if cell_is_complete
                if get_messages_only
                    return 'No error'
                @markValid(cell, callback)
                if not @validating_all_cells and run_completion_check
                    @checkIfProductIsComplete(product, cell)
            else
                if get_messages_only
                    return messages.join('<br>')
                @markIncomplete(cell, callback)
                @setProductCompletion(product, false)

    getValidationMessage: (elem) =>
        coords = @hot.getCoords(elem)
        cell =
            value: @hot.getDataAtCell(coords.row, coords.col)
            row: coords.row
            prop: @hot.colToProp(coords.col)

        # returns a string with the message(s)
        return @validateCell cell, null, true, true

    getValidationMessageWrapper: (event, api) =>
        # this is called directly from qTip in fancy-validation.coffee, so it's
        # parameters are weird. All we care about is the TD.
        @getValidationMessage(api.target[0])

    markInvalid: (cell, callback = null) =>
        # the `_#{cell.prop}_validation` attribute is used by the
        # validated___ cell renderers in handsontable/fancy-validation.coffee
        @_getProductAtCell(cell)?["_#{cell.prop}_validation"] =
            status: 'invalid'
            message: @getValidationMessageWrapper

        callback?(true) # we're not really using Handsontable's validation anymore

        @updateValidationAlert('invalid')

        return false

    markIncomplete: (cell, callback = null) =>
        # the `_#{cell.prop}_validation` attribute is used by the
        # validated___ cell renderers in handsontable/fancy-validation.coffee
        @_getProductAtCell(cell)?["_#{cell.prop}_validation"] =
            status: 'incomplete'
            message: @getValidationMessageWrapper

        callback?(true)

        @updateValidationAlert()

        return true

    markValid: (cell, callback = null) =>
        delete @_getProductAtCell(cell)?["_#{cell.prop}_validation"]

        callback?(true)

        @updateValidationAlert()

        return true

    getValidationStatus: (callback) =>
        # This check is very computationally intensive if there are a lot of
        # products and/or columns, so we cache the callback and use debounce
        # here to prevent it from eating the user's CPU.
        @_cached_validation_status_callbacks.push callback

        if not @_getValidationStatusDebounced?
            @_getValidationStatusDebounced = debounce () =>
                invalid = false
                incomplete = false
                # Using 'do' allows us to break multiple loops at once.
                do () =>
                    for product in @scope.products
                        for prop, column of @all_columns
                            if product["_#{prop}_validation"]?.status is 'invalid'
                                invalid = true
                                return
                            if product["_#{prop}_validation"]?.status is 'incomplete'
                                incomplete = true
                                # Don't stop the check yet because there may be one
                                # or more invalid cells as well. If there are, the
                                # status should be "invalid", not "incomplete".

                if invalid
                    status = 'invalid'
                else if incomplete
                    status = 'incomplete'
                else
                    status = 'valid'

                for cached_callback in @_cached_validation_status_callbacks
                    cached_callback(status)
                @_cached_validation_status_callbacks = []

                # debounce uses setTimeout, so we also have to update the scope
                @scope.$apply()

        @_getValidationStatusDebounced()

    updateValidationAlert: (status = null) =>
        if @validating_all_cells
            # don't even bother if we're validating everything (we'll call
            # updateValidationAlert() again after it's done)
            return

        @_cached_validation_statuses.push status
        if not @_updateValidationAlertDebounced?
            @_updateValidationAlertDebounced = debounce () =>
                # use only the most severe status passed to updateValidationAlert
                statuses = ['invalid', 'incomplete', 'valid', null]
                for status in statuses
                    if status in @_cached_validation_statuses
                        break

                # if no statuses were passed in, we need to get it first
                if not status?
                    @getValidationStatus (status) =>
                        @updateValidationAlert(status)
                    return

                # set the alert appropriately
                switch status
                    when 'invalid'
                        trigger_resize = @scope.alert_type is ''
                        @showError 'Highlighted values are invalid. Hover over them for details. (If you don\'t see any highlighted values, you may have to scroll to find them.)', false
                    when 'incomplete'
                        trigger_resize = @scope.alert_type is ''
                        @showWarning 'Highlighted values are required for product recommendations. Hover over them for details. (If you don\'t see any highlighted values, you may have to scroll to find them.)', false
                    when 'valid'
                        trigger_resize = @scope.alert_type isnt ''
                        @clearAlert()
                    else
                        throw new Error("#{status} is not a valid validation status")

                if trigger_resize
                    # account for the changed presence/absence of the alert box
                    angular.element(@window).trigger('resize')

                @_cached_validation_statuses = []

                # debounce uses setTimeout, so we also have to update the scope
                @scope.$apply()

        @_updateValidationAlertDebounced()

    showInvalidCells: () =>
        # First check if there are any invalid cells already visible.
        # (I had to hack Handsontable to add these functions... Sigh. I don't
        # know why they didn't just include them out of the box.)
        visible_props = [@hot.getFirstVisibleColumn() .. @hot.getLastVisibleColumn()].map (col) =>
            return @hot.colToProp(col)

        for row in [@hot.getFirstVisibleRow() .. @hot.getLastVisibleRow()]
            # We can call getSourceDataAtRow directly here because we're only
            # dealing with cells that we know are in the table.
            product = @hot.getSourceDataAtRow(row)
            for prop in visible_props
                if product["_#{prop}_validation"]?.status is 'invalid'
                    # There's an invalid cell visible. Don't move the viewport.
                    @hot.selectCellByProp(row, prop)
                    return

        # Ok, it's not visible. Let's find the first invalid cell!
        first_invalid_cell = null
        for product, i in @scope.products
            # The index is our guess at the row number of the product, which
            # should be right if the table sorting hasn't changed, and which
            # will make this check a lot faster. Returns -1 if it's not found.
            row = @hot.getRowOfSourceData(product, i)
            for prop, col of @all_columns
                if product["_#{prop}_validation"]?.status is 'invalid'
                    # We found an invalid cell! Sweet!
                    if not first_invalid_cell?
                        first_invalid_cell = [row, prop]

                    # The row isn't in the table. We'll assume that's because
                    # it's inactive and show_inactive_products is false.
                    # (There's currently no other reason for it not to be. If
                    # that ever changes, we'll need to update this.)
                    if row is -1
                        @scope.show_inactive_products = true

                    # Make sure the category containing the column is selected.
                    # (Using 'do' allows us to break multiple loops at once.)
                    do () =>
                        column = @all_columns[prop]
                        for category in @scope.categories
                            for heading in category.headings
                                if column in heading.columns
                                    category.active = true
                                    return

        # Once all the showing stuff is done, select the invalid cell, which
        # automatically scrolls the viewport too. Nice!
        @timeout () =>
            @hot.selectCellByProp(first_invalid_cell...)

    checkIfProductIsComplete: (product, cell) =>
        # Check validation to make sure the product is both valid and complete.
        validators = []
        for prop, column of @all_columns
            # Use `do` to protect the value of `prop` for the callback
            do (prop) =>
                validators.push @q (resolve, reject) =>
                    @validateCell {
                        value: product[prop]
                        row: cell.row
                        index: cell.index
                        prop: prop
                    }, (result) =>
                        # Don't use result - it will always be true.
                        # Note that invalid cells don't count as complete.
                        if product["_#{prop}_validation"]?.status in ['invalid', 'incomplete']
                            reject()
                        else
                            resolve()
                    , false # the run_completion_check flag prevents infinite loops

        # Only mark the product as valid if all validators resolve.
        @q.all(validators).then () =>
            @setProductCompletion(product, true)
        # Note: We don't actually need to set it to false if the check fails
        # because validateCell() and _checkCellCompletion() already do that

    setProductCompletion: (product, val) =>
        old_val = product.is_placeable
        product.is_placeable = val

        if val isnt old_val
            # Create a Handsontable-esque array of changes and update save data
            # Note: The first item is normally the row, but we're passing the
            # product instead because it's simpler, and _updateSaveData() can
            # easily check for that.
            @_updateSaveData [[product, 'is_placeable', old_val, val]]


    ##########
    # Saving #
    ##########

    _updateSaveData: (changes) =>
        # We want to track changed cells so we can save only those values.
        # `changes` is an array of arrays, with each representing a cell:
        # [[row, prop, oldVal, newVal], ...]
        for change in changes
            if change?.length isnt 4
                continue

            [row, prop, old_val, val] = change

            # don't bother with non-editable columns
            if not @all_columns[prop]?.is_editable and prop isnt 'is_placeable'
                continue

            if $.isNumeric(row)
                product = @hot.getSourceDataAtRow(row)
            else if typeof row is 'object'
                product = row

            # find previous changes for this product
            save_obj = _.head _.filter(@save_data, { id: product.id })
            if save_obj?
                save_obj[prop] = val
            else
                # if we didn't find any, create a new object and add it
                save_obj = { id: product.id }
                save_obj[prop] = val
                @save_data.push save_obj

    save: () =>
        @validating_all_cells = true
        @loader.overMap 'Validating ratings...'

        return @q (resolve, reject) =>
            @validateAllData().then () =>
                @validating_all_cells = false
                @getValidationStatus (status) =>
                    @updateValidationAlert(status)
                    if status in ['valid', 'incomplete']
                        result = @_doSave()
                        resolve(result)
                    else
                        reject()
                        @showInvalidCells()
                    @loader.hideAll()

    _doSave: () =>
        # include the row number for reference too
        # save_obj.row = row # this doesn't work with handsontable's sorting
        if not @save_data.length
            @showInfo('No changes detected since last save')
            return true

        promise = @repo.updateRatings(@scope.selected.crop.lineups_id, @save_data).then (response) =>
            if response.status?.type isnt 'success'
                @showUpdateError('product ratings', response.status?.msg)
                return

            @showSuccess('Ratings updated')

            # clear the array
            @save_data = []

            # update edited by/at info

        .catch (response) =>
            @showUpdateError('product ratings')

        return promise

    exportToExcel: (crop) =>
        params = $.param
            lineups_id: crop.lineups_id
            sort_props: @sort_props
            sort_direction: @sort_direction
            show_inactive: @scope.show_inactive_products
        @window.open "backend/portal/ratings/ratings/export?#{params}"
        return
